<div class="sidebar-user text-center">
    <img class="img-90 rounded-circle" src="{{profile?.profilePicLink}}" alt="">
    <div class="badge-bottom"></div>
    <h6 routerLink="/user" class="mt-3 f-14 f-w-600">{{profile?.forName}} {{profile?.surName}}</h6>
    <ul>
      <li><span><span class="counter">{{profile?.anrede}}</span></span>
        <p>{{"PRIVATEPROFILE_TITLE" | translate}}</p>
      </li>
      <li><span>{{profile?.city}}</span>
        <p>{{"EVENT_PLACE" | translate}}</p>
      </li>
      <li><span>{{profile?.premium ? 'Premium' : 'Non premium'}}</span>
        <p>Premium</p>
      </li>
    </ul>
</div>
